import { get } from 'svelte/store';
import { ACCOUNT_STATUS } from '$lib/stores/user/constants';
import { user } from '$lib/stores/user/store';
import { REG_PATH_EXCEPTION_HANDLER } from '$lib/services/auth/policy-exception-handler';
import { LOGGED_OUT_USERS_ONLY } from '$lib/services/auth/policies';
import { FlutterAppService } from '$lib/services/flutter-app';
import { postAuthenticationPathService } from '$lib/services/post-authentication-path';
import { has1_0Account, has2_0Account } from '$lib/utils/aofl-accounts';
import { DESKTOP_CHOICE, PAGES } from '$lib/utils/constants';
import { app } from '$lib/stores/app/store';
import { AnalyticsService } from '$lib/services/analytics';

export const policy = LOGGED_OUT_USERS_ONLY;

async function get1_0Path() {
	const accountStatus = get(user).accountStatus;
	if (accountStatus == ACCOUNT_STATUS.INACTIVE && has2_0Account()) {
		// The html5 layer can normally handle redirects, but we want to try and reactivate legacy or 2.0-originating users into 2.0
		return PAGES.INTERNAL.REACTIVATION;
	} else if (accountStatus == ACCOUNT_STATUS.FREE && has2_0Account()) {
		// The html5 layer can normally handle redirects, but we want to try and subscribe them into 2.0
		return PAGES.INTERNAL.SUBSCRIPTION;
	} else {
		return PAGES.INTERNAL.INSIDE_PAYWALL;
	}
}

async function get2_0Path() {
	if (get(app).meta.browserPlatform === 'safari') {
		// 2.0 is not yet supported in Safari, so redirect to download app
		return PAGES.INTERNAL.DOWNLOAD_APP;
	}
	const url = await FlutterAppService.buildWebAppUrl();
	await AnalyticsService.trackClientDebug({
		eventSubType: 'mkt-exit-event',
		source: 'FlutterAppService: navigateToWebApp',
		destination: url
	});
	return url;
}

export const policyExceptionHandler = async () => {
	const nextPath = postAuthenticationPathService.getRedirectPath(get(user));
	if (nextPath && nextPath !== PAGES.INTERNAL.DOWNLOAD_APP) {
		return nextPath;
	}

	if (get(app).meta.isMobileViewer) {
		return PAGES.INTERNAL.DOWNLOAD_APP;
	}

	const has1_0 = has1_0Account();
	const has2_0 = has2_0Account();
	const hasMixed = has1_0 && has2_0;

	if(hasMixed) {
		const desktopChoice = get(user).desktopChoice;
		if (desktopChoice === DESKTOP_CHOICE.ABCMOUSE_2_0) {
			return await get2_0Path();
		}
		if (desktopChoice === DESKTOP_CHOICE.ABCMOUSE_CLASSIC) {
			return await get1_0Path();
		}
		return PAGES.INTERNAL.DOWNLOAD_APP;
	} else if(has2_0) {
		return await get2_0Path();
	} else if(has1_0) {
		return await get1_0Path();
	}
	// This will probably never happen, but just in case, use the exception handler for the next step
	return await REG_PATH_EXCEPTION_HANDLER();
}
